document.addEventListener('DOMContentLoaded', function () {
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const countupEls = entry.target.querySelectorAll('[data-countup]');
                countupEls.forEach(el => {
                    const target = parseInt(el.getAttribute('data-countup') || el.textContent, 10);
                    const duration = 3250; // Total Time
                    const start = performance.now();

                    function easeInOutQuad(t) {
                        return t < 0.5
                            ? 2 * t * t // if
                            : -1 + (4 - 2 * t) * t; // else
                    }

                    function animate(now) {
                        const elapsed = now - start;
                        const progress = Math.min(elapsed / duration, 1);
                        const easedProgress = easeInOutQuad(progress);
                        const current = Math.round(easedProgress * target);
                        el.textContent = current;

                        if (progress < 1) {
                            requestAnimationFrame(animate);
                        } else {
                            el.textContent = target;
                        }
                    }

                    requestAnimationFrame(animate);
                });

                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.5 });

    const statsSection = document.querySelector('[class*="stats-module-b"]');
    if (statsSection) {
        observer.observe(statsSection);
    }
});